import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import companiesServices from "../../../services/http/peoples/company.service";


export const fetchCompanies = createAsyncThunk(
  "companies/fetchCompanies",
  async (isAuthenticated) => {
    try {
      if (isAuthenticated) {
        const response = await companiesServices.companiesList();
        return response.data;
      }
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
);


const initialState = {
  companies: [],
  status: 'idle',
};

export const companiesSlice = createSlice({
  name: "companies",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.companies = action.payload;
      })
      .addCase(fetchCompanies.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default companiesSlice.reducer;